module.exports = __webpack_public_path__ + "img/Profit.b69eaaca.svg";